import React from 'react'
import { FaFacebook, FaTwitter, FaYoutube,FaAngleRight } from 'react-icons/fa';
import {  Link } from "react-router-dom";
  function Footer(){
	return(
		  <>
      <section class="section-footer">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-4">
          <div class="widget-a">
            <div class="w-header-a">
              <h5 class="w-title-a text-brand">Nature Hearing Aid Service</h5>
            </div>
            <div class="w-body-a">
              <p class="w-text-a color-text-a">
              We offer an on site service and repairs lab where we can service Most Major Brands of Hearing Aids, typically the same day. Occassionally, aids do need to be sent to the factory for severe repairs. 
              </p>
            </div>
            <div class="w-footer-a">
              <ul class="list-unstyled">
                <li class="color-a">
                  <span class="color-text-a">Phone .</span>+91 990 292 8259</li>
                <li class="color-a">
                  <span class="color-text-a">Email .</span> sures.p3@gmail.com</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 section-md-t3">
          <div class="widget-a">
            <div class="w-header-a">
              <h3 class="w-title-a text-brand">The Company</h3>
            </div>
            <div class="w-body-a">
              <div class="w-body-a">
                <ul class="list-unstyled">
                  
                  <li class="item-list-a">
                  <FaAngleRight /> <Link to="/">Home</Link>
                  </li>
                  <li class="item-list-a">
                  <FaAngleRight /> <Link to="/About">About Us</Link>
                  </li>
                  <li class="item-list-a">
                  <FaAngleRight /> <Link to="/Gallery">Gallery</Link>
                  </li>
                  <li class="item-list-a">
                  <FaAngleRight /> <Link to="/Services">Services</Link>
                  </li>
                  <li class="item-list-a">
                  <FaAngleRight /> <Link to="/Press-Release">Press Release</Link>
                  </li>
                  <li class="item-list-a">
                  <FaAngleRight /> <Link to="/Contact">Contact</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 section-md-t3">
          <div class="widget-a">
            <div class="w-header-a">
              <h3 class="w-title-a text-brand">Social networks</h3>
            </div>
            <div class="icon-box-content">
                    <div class="socials-footer">
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <a href="#" class="link-one">
                            <FaFacebook/>
                            
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a href="#" class="link-one">
                            <FaTwitter/>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a href="#" class="link-one">
                           <FaYoutube/>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a href="#" class="link-one">
                            <i class="fa fa-pinterest-p" aria-hidden="true"></i>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a href="#" class="link-one">
                            <i class="fa fa-dribbble" aria-hidden="true"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
          </div>
        </div>
      </div>
    </div>
  </section>
		  <footer id="footer">
    <div class="container">
      <div class="copyright">
        &copy; 2019 Copyright <strong>Nature Hearing Aid Service  & Production Lab</strong>. All Rights Reserved
      </div>
      <div class="credits">
         
       
       
      </div>
    </div>
  </footer>
 		  </>
 )
	}
 export default Footer